export default __webpack_public_path__ + "static/media/Aura-Egg__09.0e596f8d.png";